// var $ = $ || jQuery;
var $ = require('jquery');

// ====================================
//  Results Card
// ====================================

    class ResultsCard
    {
        constructor(p_element, p_config)
        {
            this._element = null;

            this.statusIndicator = null;
            this.statusBar = null;
            this.status = null;
            
            this.winner = null;
            this.title = null;
            this.image = null;
            this.rd = null;
            this.td = null;

            this.data = null;

            this.totalDelegates = p_config.td || 0;
            this.neededToWin = p_config.nom || 0;

            if(this.element = p_element || null) this.init();
        }

        init()
        {
            
        }

        buildCard(p_element)
        {
            //  Capture base styles
            this.baseStyleClass = p_element.attr('class');
            
            //  Build main display
            this.image = $("<div class='cnn-delegate-roll-call__image'><img class='cnn-delegate-roll-call__image__src' /></div>").appendTo(p_element);
            this.rd = $("<p class='cnn-delegate-roll-call--results-card__rd' data-rd=\"0\"></p>").appendTo(p_element);

            //  Build status
            this.status = $("<div class='cnn-delegate-roll-call--results-card__status'></div>").appendTo(p_element);
            
                //  Build status bar
                this.statusBar = $("<div class='cnn-delegate-roll-call--results-card--status-bar'></div>").appendTo(this.status);
                this.statusIndicator = $("<div class='cnn-delegate-roll-call--results-card--status-bar__indicator'></div>").appendTo(this.statusBar);
                
                //  Build status labels
                this.td = $("<p class='cnn-delegate-roll-call--results-card__td' data-td=\"0\">" + formatNumber(this.totalDelegates) + "</p>").appendTo(this.status);
                this.nom = $("<p class='cnn-delegate-roll-call--results-card__nom' data-nom=\"0\">" + formatNumber(this.neededToWin) + "</p>").appendTo(this.status);

            this.title = $("<h4 class='cnn-delegate-roll-call__title'>Title</h4>").appendTo(p_element);
            this.winner = $("<span class='cnn-delegate-roll-call__winner'></span>").appendTo(p_element);

            return p_element;
        }

        deconstructCard()
        {

        }

        update(p_data)
        {
            if(this.element)
            {
                if(p_data)
                {
                    if(p_data !== this.data)
                    {
                        //  If this is the first time the card is recieving data OR the candidate has been updated.
                        
                        if(this.data === null || (p_data['id'] && p_data['id'] !== this.data['id']))
                        {
                            var candidate = getCandidateById( p_data['id'] ),
                                candidateName = candidate['lname'].toLowerCase();

                            this.element.attr({ 'class' : (this.baseStyleClass + " " + candidateName) });
                            
                            if(this.title) this.title.html( candidateName );

                            if( !isModule() )
                            {
                                if(this.image) this.image.find('img').attr({ 'src' : process.env.CDN + 'media/images/' + candidateName + '.' + (candidateName == 'other' ? 'png' : 'jpg') });
                            }
                        }
                        
                        //  If there are votes to display

                        if(!isNaN(parseInt(p_data['rd'])) && (p_data['rd'] !== undefined || p_data['rd'] !== null))
                        {
                            if(this.rd) this.rd.data({ 'rd' : parseInt(p_data['rd']) }).html( formatNumber(p_data['rd']) );
                            if(this.statusIndicator) this.statusIndicator.css({ 'width' : (((parseInt(p_data['rd']) / this.totalDelegates) * 100) + "%") });

                            if( parseInt(p_data['rd']) >= this.neededToWin )
                            {
                                this.element.addClass('winner');
                            }
                            else
                            {
                                this.element.removeClass('winner');
                            }
                        }

                        //  Set data as new data;

                        this.data = p_data;
                    }
                    // else
                    // {
                    //     console.log("Data hasn't changed.")
                    // }
                }
                else
                {
                    console.warn("No data was supplied.")
                }
            }
            else
            {
                console.warn("This ResultsCard is not connected to a DOM element. Please assign a DOM element to this card.")
            }
        }

        // ----------------------------
        //  Getters / Setters
        // ----------------------------

        get element()
        {
            return this._element;
        }

        set element(p_element)
        {
            if(this._element !== null)
            {
                this.deconstructCard();
            }

            this._element = this.buildCard(p_element);
        }
    }

// ====================================
//  Helper Functions
// ====================================

    function formatNumber(p_num)
    {
        return p_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function showFullResults()
    {
        return CNN.interactive.roll_call.showFullResults;
    }

    function isModule()
    {
        return CNN.interactive.roll_call.isModule();
    }

    function getData()
    {
        return CNN.interactive.roll_call.data;
    }

    function getOverlay()
    {
        return CNN.interactive.roll_call.overlay;
    }

    function getCandidateById(p_id)
    {
        return CNN.interactive.roll_call.getCandidateById(p_id);
    }

// ====================================
//  Exports
// ====================================

    exports.ResultsCard = ResultsCard;



/** WEBPACK FOOTER **
 ** ./src/js/mod/roll-call-mod--results-card.js
 **/